import { ArrowRight } from 'lucide-react';

import { PrimaryCTA } from '../components/PrimaryCTA';
import { SecondaryCTA } from '../components/SecondaryCTA';
import { SectionWrapper } from '../components/SectionWrapper';

import styles from './InstitutionsHeroSection.module.css';

export function InstitutionsHeroSection() {
  return (
    <SectionWrapper background="white" data-testid="institutions-section-hero">
      <div className={styles.copy}>
        <p className={styles.eyebrow}>FOR INSTITUTIONS</p>
        <h1 className={styles.title}>
          One partner. The whole stack. At a price your inclusive-access program
          can actually sustain.
        </h1>
        <p className={styles.subhead}>
          Kudu replaces the publisher, the homework system, the clicker app,
          and the AI subscription — and lets you bring
          a single, affordable product to every student with clear economics for
          institutions. Setup takes about as long as making coffee.
        </p>
        <div className={styles.actions}>
          <PrimaryCTA
            href="/contact"
            icon={<ArrowRight aria-hidden="true" size={16} />}
            label="Start a conversation"
          />
          <SecondaryCTA href="/faculty" label="See faculty view" />
        </div>
      </div>
    </SectionWrapper>
  );
}
